import { tracked } from 'tracked-built-ins';
import { action } from '@ember/object';
import { softTest } from 'rise-ui/utils/object';

export class ParamsHandler {
  params = tracked({});
  serializedParams = tracked({});
  @action setParams(params, transition) {
    const { params: storedParams, serializedParams } = this;
    const { queryParams } = transition.to;
    let result = false;
    for (const [ key, deserialized ] of Object.entries(params)) {
      const serialized = queryParams[key];
      if (softTest(serializedParams, key, serialized, true)) {
        result = true;
        serializedParams[key] = serialized;
        storedParams[key] = deserialized;
      }
    }
    return result;
  }
}
